// Messages de résultat d'une action : succès (bandeau vert temporaire mais lisible) ou erreur.
// Un succès n'est affiché qu'après la réponse positive du serveur.
import { Bandeau, type TypeBandeau } from '@cc/ui';
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import styles from './commun.module.css';

interface Message {
  id: number;
  type: TypeBandeau;
  texte: string;
}

interface ValeurMessages {
  afficher: (type: TypeBandeau, texte: string) => void;
}

const Contexte = createContext<ValeurMessages>({ afficher: () => undefined });
let compteur = 0;

export function FournisseurMessages({ children }: { children: ReactNode }) {
  const [messages, setMessages] = useState<Message[]>([]);
  const fermer = useCallback((id: number) => setMessages((m) => m.filter((x) => x.id !== id)), []);
  const afficher = useCallback((type: TypeBandeau, texte: string) => {
    compteur += 1;
    const id = compteur;
    setMessages((m) => [...m.slice(-2), { id, type, texte }]);
  }, []);
  const valeur = useMemo(() => ({ afficher }), [afficher]);
  return (
    <Contexte.Provider value={valeur}>
      {children}
      <ZoneMessages messages={messages} fermer={fermer} />
    </Contexte.Provider>
  );
}

function ZoneMessages({ messages, fermer }: { messages: Message[]; fermer: (id: number) => void }) {
  if (messages.length === 0) return null;
  return (
    <div
      className={styles.messages}
      style={{ position: 'fixed', right: 16, bottom: 84, zIndex: 60, maxWidth: 'min(440px, calc(100vw - 32px))' }}
      aria-live="polite"
    >
      {messages.map((m) => (
        <Bandeau key={m.id} type={m.type} onFermer={() => fermer(m.id)} dureeMs={m.type === 'succes' ? 10_000 : undefined}>
          {m.texte}
        </Bandeau>
      ))}
    </div>
  );
}

export function useMessages(): ValeurMessages {
  return useContext(Contexte);
}
